module.exports = __webpack_public_path__ + "img/four-two.aa3aeeb6.png";